import { get_axios_instance, api_variables, errorHandler } from '@/apis/variables.js';

var axios_instance = get_axios_instance(api_variables.SERVICE_SMTP_SETTINGS);

const state = {
    data: {},
    isFetching: false,
    isSaving: false,
    isDeleting: false,
    editMode: false,
    record: {}
};

const getters = {
    getSmtpSettings: (state) => {
        if (state.data) {
            return state.data
        } else {
            this.fetchAll()
        }
    },
    editMode: (state) => {
        return state.editMode
    },
    record: (state) => {
        return state.record
    }
}

const mutations = {
    set: (state, payload) => {
        state.data = payload;
    },

    addSmtpSettings: (state, payload) => {
        state.data = payload;
    },

    setFetching: (state, payload) => {
        state.isFetching = payload;
    },

    setSaving: (state, payload) => {
        state.isSaving = payload;
    },

    setDeleting: (state, payload) => {
        state.isDeleting = payload;
    },

    setEditMode: (state, payload) => {
        state.editMode = payload.editMode;
        state.record = payload.record;
    }
}

const actions = {
    async fetchAll({ commit }, payload) {
        try {
            commit("setFetching", true);
            let res = await axios_instance.get(`/`, {
                params: { le_id: payload }
            });
            commit("setFetching", false);
            if (res.status == 200) {
                commit("set", res.data.payload);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async create({ commit }, payload) {
        try {
            commit("setSaving", true);
            let res = await axios_instance.post(`/`, {
                data: payload
            });
            commit("setSaving", false);
            if (res.status == 200) {
                commit("addSmtpSettings", res.data);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}